import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const SpeakerIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M19.74 6.91C19.35 6.59 18.79 6.65 18.47 7.04C18.15 7.43 18.21 7.99 18.6 8.31C19.81 9.29 20.58 10.78 20.59 12.45C20.57 14.12 19.8 15.61 18.6 16.59C18.21 16.91 18.15 17.47 18.47 17.86C18.79 18.25 19.35 18.31 19.74 17.99C21.35 16.68 22.38 14.69 22.4 12.45C22.38 10.22 21.35 8.22 19.74 6.91Z"
            fill="currentColor"
         />
         <path
            d="M17.47 9.71C17.08 9.39 16.52 9.45 16.2 9.84C15.88 10.23 15.94 10.79 16.33 11.11C16.72 11.43 16.97 11.91 16.99 12.45C16.97 12.99 16.72 13.48 16.33 13.79C15.94 14.11 15.88 14.67 16.2 15.06C16.52 15.45 17.08 15.51 17.47 15.19C18.26 14.54 18.78 13.55 18.79 12.45C18.77 11.34 18.26 10.36 17.47 9.71Z"
            fill="currentColor"
         />
         <path
            d="M12.88 4C12.61 4 12.34 4.1 12.14 4.28L7.06 8.8H4.1C2.94 8.8 2 9.74 2 10.9V14C2 15.16 2.94 16.1 4.1 16.1H7.06L12.14 20.62C12.35 20.8 12.61 20.9 12.88 20.9C13.5 20.9 14 20.4 14 19.78V5.12C14 4.5 13.5 4 12.88 4ZM12.2 18.26L8 14.53C7.83 14.38 7.62 14.3 7.4 14.3H4.1C3.93 14.3 3.8 14.17 3.8 14V10.9C3.8 10.74 3.94 10.6 4.1 10.6H7.4C7.62 10.6 7.83 10.52 8 10.37L12.2 6.64V18.26Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default SpeakerIcon
